import * as React from 'react';
import { connect } from 'react-redux';
import './KilometersOnCar.css';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { Form, Button } from 'react-bootstrap';
import { showModalKiloCheck } from '../../../../actions/salesModalActions';

class KilometersOnCar extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            totalKM: Number(this.props.sales.kilometersOnCar) === 0 ? "" : this.props.sales.kilometersOnCar,
            validInput: true,
            exceedKM:false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.validateInput = this.validateInput.bind(this);
    }

    async componentDidMount() {
        this.validateInput(this.state.totalKM);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = await e.target.value.replace(/[^0-9]/gi, "");
        await this.setState({ [name]: value });
        this.validateInput(Number(value));
    }

    async handleNextStep() {
        if (!this.state.nextDisabled && this.state.exceedKM === false) {
            let payload = {
                kilometersOnCar: this.state.totalKM,
            }
            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(handleNextStep());
        }

        if (this.state.exceedKM === true) {
            this.props.dispatchAction(showModalKiloCheck());
        }
    }

    async validateInput(value) {
        let disabled = true;
        let kmCheck = false;
        if (value > 0) {
            disabled = false;
        }
        if (value >= 200000) {
            kmCheck = true;
        }
        this.setState({ validInput: disabled });
        this.setState({ exceedKM: kmCheck });
    }

    public render() {
        const { totalKM} = this.state;
        return (
            <div>
                <p className="text-16 text-center font-weight-500 mb-17px mt-30px">Tell us, more or less, how many kms your car has driven in total.</p>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="form-row mb-lg-1 mb-2">
                            <div className="col-12">
                                <div className={'form-group' + (totalKM === "" ? ' has-error' : '')}>
                                    <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.totalKM !== "" ? "" : " no-opacity")}>Total kms driven</Form.Label>
                                    <div style={{ position: "relative" }}>
                                        <span className={'km-label'}>km</span>
                                        <Form.Control type="text" placeholder="0" id="totalKMInput" name="totalKM" value={this.state.totalKM} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center mt-lg-4">
                            <Button type="submit" className="btn btn-block btn-solid-red mt-5 ml-16px mr-16px mt-lg-0 pl-3 cursor-pointer" id="NextButton" disabled={this.state.validInput} onClick={this.handleNextStep}>Next</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales : state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(KilometersOnCar);